import { render, staticRenderFns } from "./LayoutCliente.vue?vue&type=template&id=4355bae5&scoped=true&"
import script from "./LayoutCliente.vue?vue&type=script&lang=js&"
export * from "./LayoutCliente.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCliente.vue?vue&type=style&index=0&id=4355bae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355bae5",
  null
  
)

export default component.exports